import styled from "@emotion/styled";

export const Right = styled.div`
  flex: 0 1 auto;

  inline-size: 100%;
`;
